/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';

import { useInt } from 'hooks/useInt';

import styles from './ShortAnswer.module.scss';

import type { ShortAnswerProps } from './ShortAnswer.types';

export const ShortAnswer = ({ answer, className }: ShortAnswerProps) => {
  const { t } = useInt();

  return (
    <div className={cn(styles['answer'], className)}>
      <p className={styles['label']}>{t('The short answer')}</p>

      <p className={styles['text']}>{answer}</p>
    </div>
  );
};
